module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/icon_number_12-62d5618f88f901332f821a98f5e787c4.svg";